import { schema } from "normalizr";

export const includedServiceSchema = new schema.Entity("includedService", {});

export const includedServicesSchema = new schema.Array(includedServiceSchema);
